import { Injectable } from '@angular/core';
import { QuerifyService } from '@core/services/querify.service';
import { AccountPreferences, PagedResult, User } from '@interfaces';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Mutations } from './mutations';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class UsersApi {
  constructor(
    private apollo: Apollo,
    private mutations: Mutations,
    private queries: Queries,
    private querify: QuerifyService
  ) {}

  async me(): Promise<User> {
    return this.apollo
      .query({
        query: this.queries.me(),
      })
      .toPromise()
      .then((response) => response.data['me']);
  }

  async meWithAccessToken(accessToken: string): Promise<{ me: User, accountPreferences: AccountPreferences }> {
    return this.apollo
      .query({
        query: this.queries.me(),
        context: {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      })
      .toPromise()
      .then((response) => response.data as any);
  }


  save(user): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.createUser(),
      variables: {
        input: user
      }
    });
  }

  update(id, user): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.updateUser(),
      variables: {
        id: id,
        input: user
      }
    });
  }

  archiveUser(id): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.archiveUser(),
      variables: {
        id: id
      }
    });
  }

  unarchiveUser(id): Observable<any> {
    return this.apollo.mutate({
      mutation: this.mutations.unarchiveUser(),
      variables: {
        id: id
      }
    });
  }

  search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.getUsers(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['users'];
        })
      );
  }

  searchOne(id: String): Observable<User> {
    return this.apollo
      .query({
        query: this.queries.getUser(),
        variables: { id: id }
      })
      .pipe(
        map(({ data }) => {
          return data['user'];
        })
      );
  }
}
